import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import Box from "@mui/material/Box";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const AffiliationModal = ({
  open,
  onClose,
  affiliatedStudents,
  toTitleCase,
  isSchoolAdmin,
  isSelPanel,
  isRecorder,
  canDriveSelection,
  adminStatus,
  selectedStudents,
  setSelectedStudents,
  affiliationName,
}) => {
  console.log("Affiliated Students:", affiliatedStudents);
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xl">
      <DialogTitle
        sx={{
          bgcolor: "primary.main",
          color: "white",
          textAlign: "center",
          fontWeight: "bold",
          mb: 2,
        }}
      >
        Students Matching Affiliation{" "}
        {affiliationName && ` – ${affiliationName}`}
      </DialogTitle>
      <DialogContent>
        <TableContainer component={Paper} sx={{ maxHeight: 600, overflowY: "auto" }}>
            <Table size="small">
           <TableHead>
            <TableRow sx={{ backgroundColor: "#f0f0f0" }}>
              <TableCell sx={{ fontWeight: "bold", position: "sticky", top: 0, backgroundColor: "#f0f0f0", zIndex: 1 }}>
                Name
              </TableCell>
              <TableCell sx={{ fontWeight: "bold", position: "sticky", top: 0, backgroundColor: "#f0f0f0", zIndex: 1 }}>
                {affiliatedStudents[0]?.moreInfoValue}
              </TableCell>
              <TableCell sx={{ fontWeight: "bold", position: "sticky", top: 0, backgroundColor: "#f0f0f0", zIndex: 1 }}>
                School
              </TableCell>
              <TableCell sx={{ fontWeight: "bold", position: "sticky", top: 0, backgroundColor: "#f0f0f0", zIndex: 1 }}>
                Total Won
              </TableCell>
              <TableCell sx={{ fontWeight: "bold", position: "sticky", top: 0, backgroundColor: "#f0f0f0", zIndex: 1 }}>
                Action
              </TableCell>
            </TableRow>
          </TableHead>
            <TableBody>
              {affiliatedStudents.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    <Typography
                      variant="body2"
                      fontStyle="italic"
                      color="textSecondary"
                      sx={{ py: 2 }}
                    >
                      No Students Found
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                [...affiliatedStudents]
                  .sort((a, b) => {
                    const schoolA = a.school?.toLowerCase() || "";
                    const schoolB = b.school?.toLowerCase() || "";
                    if (schoolA < schoolB) return -1;
                    if (schoolA > schoolB) return 1;

                    const nameA = `${a.last_name} ${a.first_name}`.toLowerCase();
                    const nameB = `${b.last_name} ${b.first_name}`.toLowerCase();
                    return nameA.localeCompare(nameB);
                  })
                  .map((student, index) => {
                  const totalAwards = student.awardHistory?.reduce(
                    (sum, award) => sum + (award.award_amount || 0),
                    0
                  );

                  const isNominated = selectedStudents.some(
                    (s) => s.id === student.id
                  );

                  const canNominate = canDriveSelection;

                  return (
                    <TableRow
                      key={student.id}
                      sx={{
                        backgroundColor: student.rejected
                          ? "#ffe6e6"
                          : index % 2 === 0
                          ? "#fafafa"
                          : "white",
                        "&:hover": {
                          backgroundColor: student.rejected
                            ? "#ffdede"
                            : "#f5f5f5",
                        },
                        ...(student.rejected && {
                          textDecoration: "line-through",
                          color: "#a00",
                        }),
                      }}
                    >
                      <TableCell>
                        <Typography variant="body2" fontWeight={500}>
                          {toTitleCase(student.first_name)}{" "}
                          {toTitleCase(student.last_name)}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Tooltip
                          title={<Typography sx={{ fontSize: 14 }}>{student.moreInfoText}</Typography>}
                          arrow
                        >
                          <Typography variant="body2">
                            {student.moreInfoText?.length > 40
                              ? `${student.moreInfoText.slice(0, 40)}…`
                              : student.moreInfoText}
                          </Typography>
                        </Tooltip>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">
                          {student.school}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Tooltip
                          title={
                            student.awardHistory?.length ? (
                              <Box>
                                {student.awardHistory.map((award, i) => (
                                  <Typography key={i} variant="body2">
                                    {award.scholarship_name}: $
                                    {award.award_amount.toLocaleString()}
                                  </Typography>
                                ))}
                              </Box>
                            ) : (
                              "No awards"
                            )
                          }
                          arrow
                        >
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Typography variant="body2">
                              {totalAwards > 0
                                ? `$${totalAwards.toLocaleString()}`
                                : "—"}
                            </Typography>
                            {totalAwards > 0 && (
                              <InfoOutlinedIcon
                                fontSize="small"
                                sx={{ ml: 1, color: "gray" }}
                              />
                            )}
                          </Box>
                        </Tooltip>
                      </TableCell>
                      <TableCell>
                        {canNominate && (
                          <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            sx={{ textTransform: "none", fontWeight: 600 }}
                            disabled={isNominated}
                            onClick={() => {
                              setSelectedStudents((prev) => [...prev, student]);
                            }}
                          >
                            Nominate
                          </Button>
                        )}
                      </TableCell>
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AffiliationModal;
